export const SET_SUB_ACTION_MENU_ANCHOR_EL = "SET_SUB_ACTION_MENU_ANCHOR_EL";
export const SET_SUB_ACTION_MENU_PLACEMENT = "SET_SUB_ACTION_MENU_PLACEMENT";
export const SET_SUB_ACTION_MENU_OPEN = "SET_SUB_ACTION_MENU_OPEN";
export const SET_SUB_ACTION_MENU_ID = "SET_SUB_ACTION_MENU_ID";